//
//
//
//
//
//
//
//
//
//
//
//

import { defaultBlockProps } from "~/helpers/data";

export default {
    name: "BowContentMediaSx",

    props: {
        ...defaultBlockProps,

        mediaToggle: {
            default: false,
            type: [Boolean, Array],
        },
    },

    data: () => ({}),
};
